import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadAutomixEngine, loadAutomixSets } from '../../redux/thunk/automixThunk';
import AutomixPicker from '../Automix/AutomixPicker';
import AutomixSetup from '../Automix/AutomixSetup';
import AutomixBuild from '../Automix/AutomixBuild';
import AutomixSetView from '../Automix/AutomixSetView';
import './AutomixTab.scss';

// Why the engine can't run here, in the user's terms.
const UNAVAILABLE = {
    'rubberband-missing': 'The time-stretch engine (Rubber Band) isn’t installed on this Mac.',
    'python-missing': 'The analysis environment isn’t set up on this Mac.',
    'engine-missing': 'The mixing engine isn’t part of this build.',
    platform: 'Automix runs on macOS for now.',
};

/**
 * Prepare > Automix — a playlist mixed into one continuous DJ set.
 *
 *   picker  → choose a playlist (or make one from files), or reopen a set
 *   setup   → the tracklist, running order, opening track, where to save
 *   build   → live stages of the engine (continues while the tab is closed)
 *   set     → the finished set: timeline, tracklist, every transition
 *
 * The build itself lives in Redux (automixThunk), not here.
 */
const AutomixTab = () => {
    const dispatch = useDispatch();
    const engine = useSelector((s) => s.automix.engine);
    const phase = useSelector((s) => s.automix.phase);
    const source = useSelector((s) => s.automix.source);
    const set = useSelector((s) => s.automix.set);

    useEffect(() => {
        dispatch(loadAutomixEngine());
        dispatch(loadAutomixSets());
    }, [dispatch]);

    const building = phase === 'building' || phase === 'stopping';
    let view;
    if (engine && !engine.available) {
        view = (
            <div className="amx-unavailable">
                <h2>Automix isn’t available here yet</h2>
                <p>{UNAVAILABLE[engine.reason] || 'The mixing engine isn’t available in this build.'}</p>
            </div>
        );
    } else if (building) view = <AutomixBuild />;
    else if (set) view = <AutomixSetView />;
    else if (source) view = <AutomixSetup />;
    else view = <AutomixPicker />;

    return <div className="tab-container automix-tab">{view}</div>;
};

export default AutomixTab;
